import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["dialog"];
  static values = {
    open: Boolean,
  };
  toggle() {
    console.log("dropdown-menu");
    this.dialogTarget.showModal();
  }

  // Allows for a closing animation since display transitions don't work yet
  close() {
    this.dialogTarget.setAttribute("closing", "");

    Promise.all(
      this.dialogTarget.getAnimations().map((animation) => animation.finished)
    ).then(() => {
      this.dialogTarget.removeAttribute("closing");
      this.dialogTarget.close();
    });
  }

  backdropClose(event) {
    if (event.target.nodeName == "DIALOG") this.close();
  }
}
